import { render, staticRenderFns } from "./SecondaryDestinationPicker.vue?vue&type=template&id=885ff344"
import script from "./SecondaryDestinationPicker.vue?vue&type=script&lang=ts"
export * from "./SecondaryDestinationPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports